import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const regionsState = (state: AppState) => state.regions;

export const regionsSelector = createSelector(regionsState, regions => regions.regionsByCountry);

export const regionSearchResultsSelector = createSelector(regionsState, regions => regions.searchResult);
